<div class="dashboard-tile">
    <app-grid-spinner #spinner></app-grid-spinner>
    <div class="tile-header">
      <div class="tile-header-title">Assessments</div>
      <div class="tile-header-action">
        <mat-slide-toggle (change)="showLastOnlyChange($event)">Most Recent Only</mat-slide-toggle>
        <button matTooltip="Refresh" matTooltipPosition="left" mat-icon-button (click)='refresh()'>
          <mat-icon aria-label="Refresh" svgIcon="cw:action_refresh"></mat-icon>
        </button>
      </div>
    </div>
    <table mat-table [dataSource]="items" class="tile-content flush" matSort matSortDisableClear>
      <ng-container matColumnDef="client">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="name">Client</th>
        <td mat-cell *matCellDef="let element"> {{element.accountName}} </td>
      </ng-container>
  
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Assessment</th>
        <td mat-cell *matCellDef="let element"> {{element.assessmentName}} </td>
      </ng-container>
  
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Type</th>
        <td mat-cell *matCellDef="let element"> {{element.assessmentType}} </td>
      </ng-container>
  
      <ng-container matColumnDef="progress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header="percentComplete">Current Assessment Progress</th>
        <td mat-cell *matCellDef="let element">
          <div class="custom-progress-bar" [ngClass]="{'progress-not-started':element.percentComplete==0}" style="width:200px">
            <div *ngIf="element.percentComplete>0" class="bg-primary" [ngStyle]="{'width': element.percentCompleteStr}">{{element.percentCompleteStr}}</div>
            <div *ngIf="element.percentComplete==0" class="bg-warn">{{element.percentCompleteStr}}</div>
          </div>
        </td>
      </ng-container>
  
      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</th>
        <td mat-cell *matCellDef="let element"> {{getLastUpdated(element) | date:'medium'}} </td>
      </ng-container>
  
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let element">
          <button [disabled]="element.status === 'COMPLETED'" matTooltip="Work on the assessment" matTooltipPosition="left" mat-icon-button (click)="workAssessment(element)">
            <mat-icon aria-label="Work on the assessment" svgIcon="cw:action_edit"></mat-icon>
          </button>
          <button [disabled]="element.status !== 'COMPLETED' || !lastCompleted.has(element.id)" matTooltip="Create a new assessment" matTooltipPosition="left" mat-icon-button (click)="newAssessment(element)">
            <mat-icon aria-label="Create a new assessment" svgIcon="cw:action_add"></mat-icon>
          </button>
          <button [disabled]="element.status !== 'COMPLETED'" matTooltip="View the assessment dashboard" matTooltipPosition="left" mat-icon-button (click)="viewAssessmentDashboard(element)">
            <mat-icon aria-label="View the assessment dashboard">insert_chart</mat-icon>
          </button>
        </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsToDisplay;" class="alternating-bg bg-accent-hover"></tr>
    </table>
    <mat-paginator class="tile-footer" [length]="resultsLength" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>
  